import { createContext } from 'react';
import type { AdultAuthService } from '../../platform/auth/adult-auth';
import type { AdultDataService } from '../../platform/supabase/adult-data';

// Supplied by the app's routes so the older planning pages (learning intent,
// plan builder, preview and approve) can render inside the same teacher
// sidebar as every other teacher screen. Absent in isolated tests, where
// those pages fall back to the plain page frame.
export type TeacherShellValue = {
  auth: Pick<AdultAuthService, 'signOut'>;
  data: Pick<AdultDataService, 'listRoleOptions'>;
};

export const TeacherShellContext = createContext<TeacherShellValue | null>(
  null,
);
